import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class OutgoingInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Security headers (CSP, HSTS, etc.) are set as response headers by the Express server in index.js.
    // They should not be sent as request headers on outgoing API calls.
    const modifiedRequest = request.clone({});

    return next.handle(modifiedRequest);
  }
}
